import safeLocalStorage from './safeLocalStorage'

export const AI_ONBOARDING_STORAGE_KEY = 'informedIaOnboardingSeenV4'

export const AI_ONBOARDING_SELECTORS = {
  headerButton: '#ai-assistant-header-btn',
}

const WELCOME_IMAGE = `${process.env.PUBLIC_URL}/onboarding/informed-ia-welcome.png`
const TOUR_TOTAL = 7

const WELCOME_DESCRIPTION = [
  'O Informed IA é o seu novo assistente médico inteligente. Você continua encontrando o conteúdo médico da Manole, confiável e conectado às referências científicas, agora de um jeito mais ágil, podendo ir além das respostas ao explorar conteúdos relacionados para aprofundar sua prática.',
  'Conheça o Informed IA e explore uma nova experiência de acesso à informação médica!',
].join('\n\n')

function renderWelcomeImage(popover) {
  if (popover.wrapper.querySelector('.informed-ia-onboarding-hero')) return

  const image = document.createElement('img')
  image.src = WELCOME_IMAGE
  image.alt = 'O que era referência, ficou ainda melhor.'
  image.className = 'informed-ia-onboarding-hero'
  popover.title.before(image)
}

let activeDriver = null

export function hasSeenAIOnboarding() {
  const storage = safeLocalStorage()
  return !!(storage && storage.getItem(AI_ONBOARDING_STORAGE_KEY) === 'true')
}

export function markAIOnboardingSeen() {
  const storage = safeLocalStorage()
  if (storage) storage.setItem(AI_ONBOARDING_STORAGE_KEY, 'true')
}

export function buildAIOnboardingSteps() {
  return [
    {
      popover: {
        title: 'Pergunta clínica com resposta rápida e contextualizada para sua rotina',
        description: WELCOME_DESCRIPTION,
        showButtons: ['next', 'close'],
        nextBtnText: 'Explorar',
        progressText: `1 de ${TOUR_TOTAL}`,
        popoverClass: 'informed-ia-onboarding informed-ia-onboarding--welcome',
        onPopoverRender: renderWelcomeImage,
      },
    },
    {
      element: AI_ONBOARDING_SELECTORS.headerButton,
      popover: {
        title: 'É aqui que o Informed IA, seu assistente inteligente, fica disponível',
        description:
          'Sempre que precisar tirar uma dúvida clínica rápida, sem sair do fluxo de leitura, é só clicar no ícone Informed IA.',
        side: 'bottom',
        align: 'start',
        showButtons: ['next', 'previous', 'close'],
        nextBtnText: 'Próximo',
        prevBtnText: 'Anterior',
        progressText: `2 de ${TOUR_TOTAL}`,
      },
    },
  ]
}

export function destroyAIOnboardingTour() {
  if (!activeDriver) return
  const instance = activeDriver
  activeDriver = null
  instance.destroy()
}

export async function startAIOnboardingTour({
  force = false,
  startIndex = 0,
  onOpenAssistant,
} = {}) {
  if (!force && hasSeenAIOnboarding()) return false

  destroyAIOnboardingTour()

  const { driver } = await import('driver.js')
  const steps = buildAIOnboardingSteps()
  let openedAssistant = false

  steps[1].popover.onNextClick = () => {
    openedAssistant = true
    activeDriver?.destroy()
  }

  activeDriver = driver({
    animate: true,
    showProgress: true,
    progressText: '{{current}} de {{total}}',
    nextBtnText: 'Próximo',
    prevBtnText: 'Anterior',
    doneBtnText: 'Próximo',
    popoverClass: 'informed-ia-onboarding',
    overlayColor: '#002d72',
    overlayOpacity: 0.72,
    stagePadding: 8,
    stageRadius: 12,
    allowClose: true,
    overlayClickBehavior: (_element, _step, { driver: instance }) => {
      if (instance.getActiveIndex() === 0) instance.destroy()
    },
    skipMissingElement: true,
    waitForElement: 1500,
    disableActiveInteraction: true,
    smoothScroll: true,
    steps,
    onDestroyed: () => {
      activeDriver = null
      markAIOnboardingSeen()
      if (openedAssistant && typeof onOpenAssistant === 'function') {
        onOpenAssistant({ continueOnboarding: true })
      }
    },
  })

  activeDriver.drive(startIndex)
  return true
}
